import Transports from './transports/transports';

type LogLevel = 'debug' | 'error' | 'info' | 'warning';

export default class Logger implements Transports {
  protected transports: Transports[] = [];

  addTransport(transport: Transports) {
    this.transports.push(transport);
  }

  debug(...args): void {
    this.log('debug', ...args);
  }

  error(...args): void {
    this.log('error', ...args);
  }

  info(...args): void {
    this.log('info', ...args);
  }

  warning(...args): void {
    this.log('warning', ...args);
  }

  private log(level: LogLevel, ...args) {
    for (const transport of this.transports) {
      transport[level](...args);
    }
  }
}
